import {from, Observable} from "rxjs";

import {Data, FileService, ReadWriteFileDriver} from "@core/services/file/file";

import "@core/drivers/fileData";


import {CacheFileDescriptor} from "./cacheFileDescriptor";
import { AttachmentStoreService_DIID } from "@archipad/services/async-upload-attachment.service";
import _LegacyServiceManager from "@core/services/legacy-service-manager";
import { blobToDataURL } from "@archipad/helpers/blob";
import { ProgressObserver } from "@archipad-js/core/progress";


export {CacheFileDescriptor as URLFileDescriptor};

class CacheFileDriverImpl implements ReadWriteFileDriver<CacheFileDescriptor> {
    public download(file: CacheFileDescriptor): Data {
        return Data.fromAsyncBlob(this.getBlob(file));
    }

    public url(file: CacheFileDescriptor): Observable<string> {
        return from((async () => {
            const blob = await this.getBlob(file);
            if (!blob) {
                return;
            }
            return blobToDataURL(blob);
                
        })());
    }

    public upload(progress: ProgressObserver|null, file: CacheFileDescriptor, data:Data): Observable<unknown>{
        throw new Error("CacheFileDriver.upload is not implemented");
    }
        
    public delete?(progress: ProgressObserver|null, source: CacheFileDescriptor): Observable<unknown>{
        return from((async () => {
            const attachmentStoreService = _LegacyServiceManager.container.get(AttachmentStoreService_DIID.symbol);
            await attachmentStoreService.deleteAttachmentCache({
                userId: source.userId,
                projectId: source.projectId,
                entityId: source.entityId,
                attachmentKey: source.attachmentPath,
            });
        })());
    }

    private async getBlob(file: CacheFileDescriptor): Promise<Blob> {
        const attachmentStoreService = _LegacyServiceManager.container.get(AttachmentStoreService_DIID.symbol);
        const attachmentCache = await attachmentStoreService.getAttachmentCache({
            userId: file.userId,
            projectId: file.projectId,
            entityId: file.entityId,
            attachmentKey: file.attachmentPath,
        });
        if (!attachmentCache) {
            return;
        }
        return attachmentCache.attachmentData;
    }

}

export const CacheFileDriver = new CacheFileDriverImpl();

FileService.registerDriver('localCache', CacheFileDriver);
